import Slide from "../../atoms/slide"

const Service = ({img, title, desc}) => {
    return (
        <div className="additional-service">
            <Slide>
                <img src={img} alt="Service" />
            </Slide>
            <div className="details">
                <h5>{title}</h5>
                <p>{desc}</p>
            </div>
        </div>
    )
}

export default Service;